import React from "react";
import ContactSection from "../components/ContactSection";
import Reveal from "../components/Reveal";
import RevealLines from "../components/RevealLines";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <section className="pt-32 lg:pt-44 pb-10 lg:pb-16 border-b border-line">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal y={12}>
            <span className="overline text-clay">CONTACT</span>
          </Reveal>
          <div className="mt-6">
            <RevealLines
              className="font-display font-black text-5xl sm:text-6xl lg:text-[104px] tracking-[-0.04em]"
              lines={[
                <span key="l1">Hai să</span>,
                <span key="l2">
                  <span className="italic font-light">ne auzim.</span>
                </span>,
              ]}
            />
          </div>
          <Reveal delay={0.55} y={16} className="mt-8 max-w-xl">
            <p className="text-inksoft text-base lg:text-lg leading-relaxed">
              Răspundem la fiecare cerere în maxim 4 ore lucrătoare. Pentru
              urgențe — sună-ne direct.
            </p>
          </Reveal>
        </div>
      </section>
      <ContactSection />
    </div>
  );
}
